module.exports = __webpack_public_path__ + "img/exit_2.485cbb9b.svg";